<fcom-drawer
  [(open)]="isSideBarOpen"
  class="ancillary-sidebar"
  tabindex="-1"
  [title]="
    ((displayAsBoundBased$ | async) ? 'services.sidebar.select.bound' : 'services.sidebar.select.flight')
      | finLocalization
  "
  [ariaClose]="'services.sidebar.close' | finLocalization"
  (closed)="sideBarClosed.emit()"
>
  <a *ngIf="skipEnabled" (click)="ctaSideBarClosed.emit()" href class="is-vishidden">{{ skipText }}</a>
  <div class="grow flex flex--column min-width fill">
    <div class="flex-1 scroll pr-medium">
      <ng-container *ngFor="let item of boundsOrFlights$ | async; let index = index">
        <div
          *finLet="toType(item) as boundOrFlight"
          class="border white-bg border rounded-large bound-or-flight"
          [class.mr-xsmall-t]="index !== 0"
          [attr.data-testid]="'subview-sidebar-segment-' + boundOrFlight.id"
        >
          <div
            class="border-bottom border flex flex--space-between flex--wrap font-body-2 pr-xsmall-y pr-small-x"
            [class.disabled]="(availability$ | finMap: [boundOrFlight.id, '0', 'isAllowedToUse'] | async) === false"
          >
            <div class="flex-1 label">
              {{ ((displayAsBoundBased$ | async) ? 'services.bound' : 'services.flight') | finLocalization }}
              {{ index + 1 }}, {{ boundOrFlight.departure.dateTime | finDateFormat: 'DATE' }}
            </div>
            <div
              *ngIf="showFareFamily && boundOrFlight.fareFamily"
              class="flex--nogrow label white-bg ps-xsmall-x rounded-medium"
            >
              {{ boundOrFlight.fareFamily.name }}
            </div>
          </div>
          <div
            class="border-bottom border pr-xsmall-y pr-small-x"
            [class.disabled]="(availability$ | finMap: [boundOrFlight.id, '0', 'isAllowedToUse'] | async) === false"
          >
            <fcom-ufo
              [departure]="{
                dateTime:
                  (boundOrFlight.departure.dateTime | finTime) +
                  ' ' +
                  (boundOrFlight.departure.dateTime | finDateFormat: 'WEEKDAY_SHORT'),
                city: locations[boundOrFlight.departure.locationCode]?.cityName,
                airportCode: boundOrFlight.departure.locationCode,
                airport: locations[boundOrFlight.departure.locationCode]?.name,
              }"
              [arrival]="{
                dateTime:
                  (boundOrFlight.arrival.dateTime | finTime) +
                  ' ' +
                  (boundOrFlight.arrival.dateTime | finDateFormat: 'WEEKDAY_SHORT'),
                city: locations[boundOrFlight.arrival.locationCode]?.cityName,
                airportCode: boundOrFlight.arrival.locationCode,
                airport: locations[boundOrFlight.arrival.locationCode]?.name,
              }"
              [airlines]="boundOrFlight.uniqueAirlineNames || [boundOrFlight.operatingAirline?.name]"
              [stops]="boundOrFlight.stops || 0"
              [duration]="boundOrFlight.duration | finDuration | async"
              [tails]="tails$ | finMap: boundOrFlight.id | async | finTailNames"
              [isByBusOnly]="isBusOnlyConnections$ | finMap: boundOrFlight.id | async"
              [isByTrainOnly]="isTrainOnlyConnections$ | finMap: boundOrFlight.id | async"
              [showViewDetails]="false"
            ></fcom-ufo>
          </div>
          <div class="pr-xsmall-y pr-small-x flex flex--column">
            <ng-container *ngIf="priorityBasedEligibilities$ | async as priorityBasedEligibilities">
              <!-- Show special notification if needed -->
              <ng-container *ngIf="includedBenefits$ | finMap: boundOrFlight.id | async as includedBenefits">
                <ng-container *ngIf="includedBenefits[0]">
                  <div
                    class="flex"
                    [class.disabled]="(confirmedOrCheckedInSegments$ | finMap: boundOrFlight.id | async) === false"
                  >
                    <fcom-icon class="block flex--nogrow icon-medium" [name]="(service$ | async)?.icon"></fcom-icon>
                    <div class="ps-xxsmall-l flex-1">
                      <h3 class="medium-type font-body-1 nordic-blue-900-text">
                        {{
                          benefitTranslations$
                            | finMap: 'title'
                            | async
                            | finLocalization: { amount: includedBenefits[0].quantity }
                        }}
                      </h3>
                      <p class="font-body-1 pr-small-b nordic-blue-900-text">
                        {{ benefitTranslations$ | finMap: 'description' | async | finLocalization }}
                      </p>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container
                *ngIf="
                  priorityBasedEligibilities[boundOrFlight.id] &&
                    (confirmedOrCheckedInSegments$ | finMap: boundOrFlight.id | async);
                  else showService
                "
              >
                <fcom-notification
                  *ngFor="let eligibility of priorityBasedEligibilities[boundOrFlight.id] || []; let last = last"
                  [class.pr-small-b]="!last"
                >
                  {{ eligibility | finLocalization }}
                  <ng-container
                    *ngIf="noAncillaryBecauseAirlineForFragment$ | async as noAncillaryBecauseAirlineForFragment"
                  >
                    <span *ngIf="noAncillaryBecauseAirlineForFragment[boundOrFlight.id] as noAncillaryBecauseAirline">
                      {{
                        noAncillaryBecauseAirlineKey$
                          | async
                          | finLocalization: { airline: noAncillaryBecauseAirline, airlines: noAncillaryBecauseAirline }
                      }}
                    </span>
                  </ng-container>
                </fcom-notification>
              </ng-container>

              <ng-template #showService>
                <div [class.disabled]="(confirmedOrCheckedInSegments$ | finMap: boundOrFlight.id | async) === false">
                  <div class="flex pr-xxsmall-b">
                    <fcom-icon class="block flex--nogrow icon-medium" [name]="(service$ | async)?.icon"></fcom-icon>
                    <h3 class="ps-xxsmall-l flex-1 font-body-1 medium-type nordic-blue-900-text">
                      {{ translations$ | finMap: 'title' | async | finLocalization }}
                    </h3>
                  </div>

                  <ng-container *ngIf="updatedServices$ | finMap: boundOrFlight.id | async as services; else noService">
                    <ng-container *ngFor="let service of services | keyvalue">
                      <p *ngIf="service.value.name" class="ps-xlarge-l" data-hj-suppress>{{ service.value.name }}</p>
                      <div class="flex" *ngFor="let includedService of service.value.included">
                        <fcom-icon
                          class="block flex--nogrow icon-medium heather-700-text"
                          [name]="SvgLibraryIcon.CHECKMARK"
                        ></fcom-icon>
                        <div
                          class="ps-xxsmall-l flex-1 font-body-1 nordic-blue-900-text"
                          *ngIf="category$ | async as category"
                        >
                          {{ translations$ | finMap: 'paid' | async | finLocalization }}:

                          {{
                            'MMB.includedProducts.' + includedService.category + '.text'
                              | finLocalization
                                : {
                                    amount: includedService.quantity,
                                    displayName: includedService.title || includedService['displayName'] || '',
                                    seatNumber: includedService.seatNumber ?? '',
                                    weight: includedService.maxBaggageWeight,
                                  }
                              | finEmpty: includedService.title
                          }}
                        </div>
                      </div>

                      <div class="flex" *ngFor="let service of service.value.added">
                        <fcom-icon
                          class="block flex--nogrow icon-medium nordic-blue-900-text"
                          [name]="SvgLibraryIcon.SHOPPING_CART"
                        ></fcom-icon>
                        <div
                          class="ps-xxsmall-l flex-1 font-body-1"
                          [ngClass]="{
                            'nordic-blue-900-text': +service.pricePerItem?.amount >= 0,
                            'medium-type': +service.pricePerItem?.amount > 0,
                          }"
                        >
                          <ng-container *ngIf="translations$ | finMap: 'inCart' | async | finLocalization as inCart"
                            >{{ inCart }}:</ng-container
                          >
                          {{
                            'MMB.includedProducts.' + service.category + '.text'
                              | finLocalization
                                : {
                                    amount: service.quantity,
                                    displayName: service.title || service['displayName'] || '',
                                    seatNumber: service.seatNumber,
                                    weight: service.maxBaggageWeight,
                                  }
                              | finEmpty: service.title
                          }}
                          <span *ngIf="service.originalPricePerItem"
                            ><span class="strike-through">{{ service.originalPricePerItem | finPrice }}</span
                            >&nbsp;</span
                          >
                          <span class="heather-700-text">{{ service.pricePerItem | finPrice }}</span>
                        </div>
                      </div>

                      <div class="flex" *ngIf="service.value.size === 0">
                        <div class="ps-xxsmall-l flex-1">
                          <div class="font-body-1 ps-xsmall-t nordic-blue-900-text ps-xlarge-l">
                            {{ translations$ | finMap: 'noSelection' | async | finLocalization }}
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
                <ng-container *ngIf="(confirmedOrCheckedInSegments$ | finMap: boundOrFlight.id | async) === false">
                  <fcom-notification
                    *ngFor="let eligibility of priorityBasedEligibilities[boundOrFlight.id] || ['services.cannotAdd']"
                    class="mr-small-t"
                  >
                    {{ eligibility | finLocalization }}
                  </fcom-notification>
                </ng-container>
              </ng-template>

              <ng-template #noService>
                <div class="flex">
                  <div class="ps-xxsmall-l flex-1">
                    <div class="font-body-1 ps-xsmall-t nordic-blue-900-text ps-xlarge-l">
                      {{ translations$ | finMap: 'noSelection' | async | finLocalization }}
                    </div>
                  </div>
                </div>
              </ng-template>

              <ng-container *ngIf="services$ | async as services">
                <ng-container *ngIf="!priorityBasedEligibilities[boundOrFlight.id]">
                  <fcom-notification
                    class="mr-small-t"
                    *ngIf="maxedOutForFragment$ | finMap: boundOrFlight.id | async; else editButton"
                  >
                    {{ translations$ | finMap: 'maxedOut' | async | finLocalization }}
                  </fcom-notification>
                  <ng-template #editButton>
                    <fcom-button
                      class="flex--self-end mr-small-t select-button"
                      [text]="
                        (services[boundOrFlight.id]?.length ? 'actions.modify' : 'actions.select') | finLocalization
                      "
                      [aria]="{
                        label:
                          ('services.sidebar.select.select' | finLocalization) +
                          ' ' +
                          (((displayAsBoundBased$ | async) ? 'services.bound' : 'services.flight') | finLocalization) +
                          ' ' +
                          (index + 1) +
                          ', ' +
                          (boundOrFlight.departure.dateTime | finDateFormat: 'DATE'),
                        role: 'button',
                      }"
                      [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
                      (clickBtn)="changeSelectedIndex.emit(index)"
                    ></fcom-button>
                  </ng-template>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <ng-container *ngIf="index === 0">
          <fcom-notification
            *ngIf="middleNotificationTranslationKey$ | async as middleNotificationTranslationKey"
            class="mr-large-y"
            [theme]="NotificationTheme.WARNING"
            data-testid="ancillary-sidebar-middle-notification"
          >
            {{ middleNotificationTranslationKey | finLocalization }}
          </fcom-notification>
        </ng-container>
      </ng-container>
    </div>

    <fcom-cta-button
      data-testid="common-booking-ancillary-sidebar-cta-button"
      class="flex--nogrow flex--self-end fill ps-xsmall-x"
      [title]="ctaButtonText | finLocalization"
      [position]="ButtonPosition.FULL"
      (buttonClicked)="ctaSideBarClosed.emit()"
    >
      <span class="gray-50-text">{{ 'subtotal' | finLocalization }}: </span>
      <span class="font-body-1">{{ subTotalPrice$ | async | finPrice | finEmpty: '&ndash;' }}</span>
    </fcom-cta-button>
  </div>
</fcom-drawer>
